export default __webpack_public_path__ + "static/media/golden_temple.6303935a.jpg";